import React from 'react';

const BricksPerBag = ({ width = 48, height = 48, ...props }) => {
  return (
    <img
      src="/assets/bricksperbag-header-48x48.svg"
      alt="Bricks Per Bag Logo"
      width={width}
      height={height}
      style={{ display: 'block' }}
      {...props}
    />
  );
};

export default BricksPerBag;
